import { type ReactNode, useEffect, useRef } from "react";

type SecurityStepHeaderProps = {
  title: string
  description: string
  icon?: ReactNode
};

export const SecurityStepHeader = ({ title, description, icon }: SecurityStepHeaderProps) => {
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    headingRef.current?.focus({ preventScroll: true });
  }, []);

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-4">
        {icon}
        <h1 ref={headingRef} tabIndex={-1} className="text-3xl font-bold leading-tight tracking-tight text-gray-900 outline-none dark:text-white">
          {title}
        </h1>
      </div>
      <p className="text-sm leading-6 text-gray-600 dark:text-gray-300">{description}</p>
    </div>
  );
};

SecurityStepHeader.displayName = "SecurityStepHeader";
